import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Types and Action Creators
 */
const { Types, Creators } = createActions({
    addShownStep: ['step'],
});

export const ShownStepsTypes = Types;
export default Creators;

/**
 * Initial State
 */
export const INITIAL_STATE = Immutable([]);

/**
 * Add a step to the list of steps that have been shown
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const addShownStep = (state, action) => {
    const newShownSteps = [...state];
    if (newShownSteps.indexOf(action.step) > -1) {
        return state;
    }
    newShownSteps.push(action.step);
    return newShownSteps;
};

/**
 *  Hookup Reducers To Types
 */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.ADD_SHOWN_STEP]: addShownStep,
});
